module.exports = __webpack_public_path__ + "assets/img/ps-4-light.b010dba2.png";